import { ConfirmDialog } from '@/design-system/components/primitives/confirm-dialog'

/**
 * Подтверждение удаления рабочего места (docs!84) — ЕДИНАЯ конфигурация `ConfirmDialog` для обеих
 * точек удаления: страница «Рабочее место» (`pages/workplace.tsx`) и список рабочих мест в
 * «Структуре» (`company/structure-manager.tsx`). Один компонент гарантирует одинаковые заголовок,
 * сообщение и набор кнопок в обеих точках.
 *
 * Запрос на удаление выполняется ТОЛЬКО из `onConfirm` (кнопка «Удалить»). Во время удаления
 * (`deleting`) кнопки «Удалить»/«Отмена» недоступны, подтверждающая показывает «Удаление…», а
 * закрытие крестиком/Escape заблокировано (в это время идёт запрос — по образцу недоступных
 * кнопок). Крестик/Escape/«Отмена» вне удаления закрывают диалог БЕЗ удаления.
 */
export function WorkplaceDeleteDialog({
  open,
  deleting,
  onConfirm,
  onClose,
}: {
  open: boolean
  deleting: boolean
  onConfirm: () => void
  onClose: () => void
}) {
  return (
    <ConfirmDialog
      open={open}
      title="Удаление рабочего места"
      message="Вы точно хотите удалить рабочее место?"
      onClose={onClose}
      // Пока идёт удаление, закрытие крестиком/Escape/кликом вне панели заблокировано и
      // согласовано с недоступными кнопками — чтобы не бросить запрос на полпути.
      closeDisabled={deleting}
      buttons={[
        {
          label: deleting ? 'Удаление…' : 'Удалить',
          variant: 'danger',
          disabled: deleting,
          onClick: onConfirm,
        },
        {
          label: 'Отмена',
          variant: 'secondary',
          disabled: deleting,
          onClick: onClose,
        },
      ]}
    />
  )
}
